var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceFinancescomponent = function SvgWorkspaceFinancescomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2c0 .825-.675 1.5-1.5 1.5-.135 0-.262-.015-.383-.053l-2.67 2.663c.038.12.053.255.053.39 0 .825-.675 1.5-1.5 1.5a1.504 1.504 0 0 1-1.447-1.89L7.89 4.197c-.12.038-.255.053-.39.053s-.27-.015-.39-.053l-3.413 3.42c.038.12.053.248.053.383 0 .825-.675 1.5-1.5 1.5S.75 8.825.75 8s.675-1.5 1.5-1.5c.135 0 .263.015.382.053l3.42-3.413A1.504 1.504 0 0 1 7.5 1.25a1.504 1.504 0 0 1 1.448 1.89l1.913 1.913c.12-.038.255-.053.39-.053s.27.015.39.053l2.662-2.67A1.275 1.275 0 0 1 14.25 2c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5Z",
    fill: "#7BC75C"
  })));
};
export default SvgWorkspaceFinancescomponent;